$('#button-scroll').on('click', function () {
    var smooth = [$('a.smooth'), 100, 750];
    $('html, body').animate({
        scrollTop: $('[id="' + $.attr(this, 'href').substr(1) + '"]').offset().top - smooth[1]
    }, smooth[2]);
    return false;
});

$('#input-radio-box').on('change', function (e) {
    if (e.target.value == '2') {
        $('#field-pin').hide();
        $('.button-balance').addClass('button-extended');
        grecaptcha.reset();
    } else {
        $('#field-pin').show();
        $('.button-balance').removeClass('button-extended');
        grecaptcha.reset();
    }
});
